<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row gutter-b">
      <div class="col-xxl-12">
        <b-card header-tag="header" footer-tag="footer">
          <template v-slot:header>
            <h6 class="mb-0">Form Admin</h6>
          </template>
          <div class="mb-4">
            <h6 class="mb-1">Name <span class="text-danger">*</span></h6>
            <b-form-input
              v-model="admin.name"
              placeholder="Name"
            ></b-form-input>
          </div>
          <div class="mb-4">
            <h6 class="mb-1">Email <span class="text-danger">*</span></h6>
            <b-form-input
              v-model="admin.email"
              placeholder="Email address"
              type="email"
            ></b-form-input>
          </div>
          <div class="mb-4" v-if="$route.name === 'admin-create'">
            <h6 class="mb-1">Password <span class="text-danger">*</span></h6>
            <b-form-input
              v-model="admin.password"
              placeholder="Password"
              type="password"
            ></b-form-input>
          </div>
          <div class="mb-4" v-if="$route.name === 'admin-create'">
            <h6 class="mb-1">Confirmation Password</h6>
            <b-form-input
              v-model="admin.confirm_password"
              placeholder="Password"
              type="password"
            ></b-form-input>
          </div>
          <div class="mb-4" v-if="$route.name !== 'admin-create'">
            <h6 class="mb-1">Old Password</h6>
            <b-form-input
              v-model="admin.old_password"
              placeholder="Masukan password lama"
              type="password"
            ></b-form-input>
          </div>
          <div class="mb-4" v-if="$route.name !== 'admin-create'">
            <h6 class="mb-1">New Password</h6>
            <b-form-input
              v-model="admin.password"
              placeholder="Masukan password baru"
              type="password"
            ></b-form-input>
          </div>
          <!-- <div class="mb-4">
            <h6 class="mb-1">Phone Number</h6>
            <b-form-input
              v-model="admin.phone_number"
              placeholder="Phone number"
            ></b-form-input>
          </div> -->
          <!-- <div class="mb-4">
            <h6 class="mb-1">Birtdate</h6>
            <b-form-input
              v-model="admin.dob"
              placeholder="Birtdate"
              type="date"
            ></b-form-input>
          </div> -->
          <!-- <div class="mb-4">
            <h6>Photo</h6>
            <b-form-file
              ref="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              @change="handleFile"
            ></b-form-file>
          </div> -->
          <div class="mb-4">
            <h6>Role <span class="text-danger">*</span></h6>
            <search-select
              v-model="admin.role_id"
              :options="roles"
            ></search-select>
          </div>
          <div class="mb-4" v-if="showCustomerBranch">
            <h6>Customer Branch</h6>
            <b-form-group>
              <multiselect
                v-model="selectedBranchId"
                :options="optionCustomerBranch"
                :multiple="true"
                label="text"
                value="value"
                track-by="value"
                :internal-search="false"
                :loading="branchLoading"
                :clear-on-select="false"
                :close-on-select="false"
                placeholder="Cari customer branch"
                @search-change="onBranchSearch"
                @select="onSelect"
                @remove="onRemove"
              >
                <span slot="noResult">Customer branch tidak ditemukan</span>
              </multiselect>
            </b-form-group>
          </div>

          <template v-slot:footer>
            <b-button
              variant="primary"
              @click="createAdmin"
              :disabled="loading"
              v-if="$route.name === 'admin-create'"
            >
              {{ loading ? "Loading..." : "Submit" }}
            </b-button>
            <b-button
              variant="warning"
              @click="updateAdmin"
              :disabled="loading"
              v-else
            >
              {{ loading ? "Loading..." : "Update" }}
            </b-button>
          </template>
        </b-card>
      </div>
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { dateToISOString } from "@/utils/helper";
import Multiselect from "vue-multiselect";
import { debounce } from "debounce";
import authMixin from "@/mixins/auth";

export default {
  name: "CreateAdmin",
  mixins: [authMixin],
  data() {
    return {
      admin: {
        name: null,
        email: null,
        password: null,
        confirm_password: null,
        // phone_number: null,
        // dob: null,
        // photo: null,
        role_id: "",
        customer_branch_ids: [],
        old_password: null,
        new_passworD: null,
      },
      photo: null,
      loading: false,
      roles: [],
      optionCustomerBranch: [],
      branchLoading: false,
      // The field is hidden until the first load proves branches exist, then
      // stays put: hiding it whenever a search returns nothing would yank the
      // input out from under the person typing in it.
      showCustomerBranch: false,
      selected: 1,
      value: null,
      options: ["list", "of", "options"],
      optionTags: [],
      selectedBranchId: [],
    };
  },
  components: {
    Multiselect,
  },
  async mounted() {
    this.getRoles();
    await this.customerBranch();

    let lastBreadcrumb = "";
    if (this.$route.name === "admin-create") {
      lastBreadcrumb = { title: "Create admin" };
    } else {
      lastBreadcrumb = { title: "Edit admin" };
      this.initData();
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "/dashboard" },
      { title: "Admin", route: "/admin" },
      lastBreadcrumb,
    ]);
  },
  methods: {
    dateToISOString,
    createAdmin() {
      let formData = new FormData();
      formData.append("name", this.admin.name);
      formData.append("email", this.admin.email);
      // formData.append("phone_number", this.admin.phone_number);
      // formData.append("dob", this.admin.dob);
      formData.append("password", this.admin.password);
      formData.append("role_id", this.admin.role_id);
      // formData.append("photo", this.photo);
      if (this.admin.customer_branch_ids.length) {
        this.admin.customer_branch_ids.forEach((id) => {
          formData.append("[]customer_branch_ids", id);
        });
      }

      if (this.admin.password != this.admin.confirm_password) {
        this.$bvModal.msgBoxOk(`Confirmation password is not match`, {
          title: "Error",
          okTitle: "Close",
          size: "sm",
          buttonSize: "sm",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
      } else {
        this.loading = true;

        const apiCall = this.$axios.post(
          `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/admin/user`,
          formData
        );

        this.apiCall(apiCall, {
          showSuccessToast: true,
          successMessage: "Admin created successfully!",
        })
          .then((result) => {
            this.loading = false;
            if (result) {
              this.$router.go(-1);
            }
          })
          .catch((error) => {
            this.loading = false;
            // Handle non-auth errors
            const message =
              error.response?.data?.message ||
              "An error occurred while creating admin";
            this.$bvModal.msgBoxOk(message, {
              title: "Error",
              okTitle: "Close",
              size: "sm",
              buttonSize: "sm",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          });
      }
    },
    handleFile(e) {
      const file = e.target.files[0];
      this.photo = file;
    },
    getRoles() {
      const apiCall = this.$axios.get(
        `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/roles`
      );

      this.apiCall(apiCall)
        .then((data) => {
          if (data) {
            this.roles = [];
            this.roles.push({
              value: "",
              text: "Select Role",
            });
            data.map((item) => {
              this.roles.push({
                value: item.id,
                text: item.name,
              });
            });
          }
        })
        .catch(() => {
          // Handle non-auth errors
          this.$bvToast.toast("Failed to load roles", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
    // Branches are searched on the server (`query`) instead of pulling 500 rows
    // and filtering in the browser, so an admin can reach a branch that falls
    // outside the first page.
    customerBranch(query = "") {
      this.branchLoading = true;

      const apiCall = this.$axios.get(
        `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/customer-branches`,
        {
          params: {
            query,
            order: "desc",
            limit: 20,
          },
        }
      );

      return this.apiCall(apiCall)
        .then((data) => {
          if (data) {
            this.optionCustomerBranch = (data.list || []).map((item) => ({
              value: item.id,
              text: item.name,
            }));
            if (this.optionCustomerBranch.length) {
              this.showCustomerBranch = true;
            }
          }
        })
        .catch(() => {
          // Handle non-auth errors
          this.$bvToast.toast("Failed to load customer branches", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.branchLoading = false;
        });
    },
    // 500ms matches the other search inputs in the CMS (customer/employee lists),
    // so one request goes out per pause rather than per keystroke.
    onBranchSearch: debounce(function (query) {
      this.customerBranch(query);
    }, 500),
    initData() {
      const apiCall = this.$axios.get(
        `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/admin/detail/${this.$route.params.id}`
      );

      this.apiCall(apiCall)
        .then((data) => {
          if (data) {
            this.admin = data;
            this.admin.customer_branch_ids = [];
            this.admin.role_id = data.role.id;
            this.admin.dob = this.dateToISOString(this.admin.dob);
            this.selectedBranchId = data.customer_branch.map((item) => ({
              text: item.name,
              value: item.id,
            }));
            this.customer_branch_ids = data.customer_branch.map(
              (item) => item.id
            );
          }
        })
        .catch(() => {
          // Handle non-auth errors
          this.$bvToast.toast("Failed to load admin details", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
    async updateAdmin() {
      // eslint-disable-next-line
      console.log("update admin");

      let formData = new FormData();
      formData.append("name", this.admin.name);
      formData.append("email", this.admin.email);
      formData.append("old_password", this.admin.old_password);
      formData.append("new_password", this.admin.password);
      formData.append("role_id", this.admin.role_id);
      if (this.admin.customer_branch_ids.length) {
        this.admin.customer_branch_ids.forEach((id) => {
          formData.append("[]customer_branch_ids", id);
        });
      }

      this.loading = true;

      const apiCall = this.$axios.put(
        `${process.env.VUE_APP_BASE_API_GARDTREX}/v1/cms/admin/${this.$route.params.id}`,
        formData
      );

      try {
        await this.apiCall(apiCall, {
          showSuccessToast: true,
          successMessage: "Admin updated successfully!",
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        // Handle non-auth errors
        const message =
          error.response?.data?.message ||
          "An error occurred while updating admin";
        this.$bvToast.toast(message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
    onSelect(newTag) {
      this.admin.customer_branch_ids.push(newTag.value);
    },
    onRemove(removeTag) {
      const index = this.admin.customer_branch_ids.findIndex(
        (item) => item === removeTag.value
      );
      this.admin.customer_branch_ids.splice(index, 1);
    },
  },
};
</script>
<style lang="scss"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
